import React, {useContext} from 'react';
import {getSectionAnswer,evalQuestionText} from "../../common/section-questions/sections";
import PropTypes from "prop-types";
import {SectionsContext} from "../contexts/SectionsProvider";
import SmartFormGroup from "./SmartFormGroup";
export default function Answer(props) {
    const context = useContext(SectionsContext)
    if (!props.question){
        return <></>
    }
    async function saveAnswer(value) {
        context.answer(props.section, props.question, value)
        if(props?.onAnswerSaved){
            props.onAnswerSaved()
        }
    }
    let value = getSectionAnswer(props.section,props.question)
        // here's the last place we can calc the number of dependent fields in personal
    if (props.question.answer.type === "agearray") {
        let appIndex = 'applicant' +props.section.applicant
        const count = props.section.props.mortgage[appIndex].personal.countDependents || 0
        let array=[]
        let dependentAges = props.section.props.mortgage[appIndex].personal.dependentAges
        if (!!dependentAges) {
            array = dependentAges.filter(age => {
                return !isNaN(parseInt(age))
            })
        }
        while (array.length < count) {
            array.push('')
        }
        while (array.length > count) {
            array.pop()
        }
        value = !array ? [] : array
    }
    const questionProps = {...props.question}
    if (typeof questionProps.text !== "string"){
        questionProps.text = evalQuestionText(props.section,props.question)
    }
    return (

        <SmartFormGroup
            floating={props?.floating}
            noLabel={props?.floating ? true: props?.noLabel}
            expandedStyle={props?.expandedStyle}
            editing={props.editing}
            defaultValue={value}
            saveAnswer={saveAnswer}
            {...questionProps}/>

    );
}
Answer.propTypes = {
    question: PropTypes.object,
    section: PropTypes.object,
};